/* ============================================================
   POST TANPA PRODUK (2026-09-18, reka bentuk diluluskan user)
   TikTok   → toggle "Pasang beg kuning" (kotak Beg kuning, Control Panel)
   Facebook → toggle "Add product"        (kotak Link produk, Control Panel)
   Kedua-dua LALAI HIDUP (= perangai lama) dan disimpan per-BROWSER, sama
   seperti AI label. Satu browser = satu akaun TikTok + satu page FB, dan
   kelayakan TikTok Shop lain daripada kelayakan affiliate FB — sebab itu dua
   toggle berasingan, bukan satu yang dikongsi.

   ⭐ KENAPA WEBAPP SAHAJA (disahkan pada versi LIVE 18 Sept — ZIP 3.9.4
      `d7a13771`, skrip TikTok 1.2.0 `ea992fd3`, skrip FB 1.2.0):
      • TikTok: background memakai `link` produk di TIGA tempat sahaja —
        senarai Showcase, ID produk untuk beg kuning, `productLink`. Link
        kosong → langkah Showcase DAN beg kuning dilangkau.
      • Facebook: robot hanya membuka "Add product" bila `shopeeLink` berisi.
      Jadi bila toggle MATI, webapp tidak menghantar link. Tiada pasang semula
      extension, tiada ubah robot.

   ⛔ "Post Only" TikTok BUKAN "tanpa beg kuning". Ia hanya melangkau langkah
      Showcase — beg kuning tetap dipasang kalau produk sudah ada dalam
      Showcase akaun. 43 akaun aktif menggunakannya (dikira 18 Sept, ~2,300
      kad). JANGAN tukar maksudnya; kini ia duduk DI BAWAH toggle beg kuning.
   ============================================================ */

export const KUNCI_BEG_KUNING = 'sesaat_beg_kuning_v1';
export const KUNCI_FB_ADD_PRODUCT = 'sesaat_fb_add_product_v1';

/* Lalai HIDUP: hanya '0' yang mematikan. Storan ditutup / rosak → HIDUP,
   supaya tiada pelanggan kehilangan beg kuning secara senyap. */
export function bacaSuisProduk(kunci) {
    try { return localStorage.getItem(kunci) !== '0'; } catch { return true; }
}

/* ⛔ Panggil dari PENGENDALI KLIK sahaja, bukan dari useEffect — effect turut
   berjalan semasa mount dan akan menyimpan nilai LALAI (perangkap yang sama
   seperti AI label + CTA beg kuning). */
export function tulisSuisProduk(kunci, hidup) {
    try { localStorage.setItem(kunci, hidup ? '1' : '0'); } catch { /* storan ditutup — abai */ }
}

/* Mod TikTok yang BERKESAN untuk satu larian. Dipakai KEDUA-DUA laluan Run
   TikTok (kalendar + tick kad) — satu takrifan, bukan kembar.
   Beg kuning MATI = video sahaja: Showcase dilangkau DAN Showcase Only dipaksa
   mati. ⛔ Showcase Only yang tersorok WAJIB mati — bila ia hidup, background
   menamatkan larian selepas langkah Showcase (yang kosong kerana tiada link)
   → TIADA video dipost, tanpa sebarang amaran.
   Beg kuning HIDUP = tepat seperti sebelum ini (Showcase ikut Post Only). */
export function modTiktokBerkesan({ begKuning = true, isPostOnly = false, isShowcaseOnly = false } = {}) {
    if (begKuning === false) return { isShowcaseMode: false, isPostOnly: true, isShowcaseOnly: false };
    return { isShowcaseMode: !isPostOnly, isPostOnly: !!isPostOnly, isShowcaseOnly: !!isShowcaseOnly };
}

/* Link produk TikTok yang dihantar kepada robot untuk satu kad. Kosong =
   robot tidak menyentuh Showcase mahupun beg kuning untuk kad itu. */
export function linkTiktokUntukRobot(kad, begKuning = true) {
    return begKuning === false ? '' : (kad?.link || '');
}
